import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getIndicatorFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`indicators.fields.title`),
      columnHeader: t(`indicators.columns.title`),
    },
    Type: {
      fieldId: 'Type',
      formLabel: t(`indicators.fields.type`),
      displayType: { displayType: 'rating', ratingKey: 'indicator_type' },
      allowAsConditionSource: true,
    },
    Unit: {
      fieldId: 'Unit',
      formLabel: t(`indicators.fields.unit`),
      columnHeader: t(`indicators.columns.unit`),
    },
    LowerToleranceNum: {
      fieldId: 'LowerToleranceNum',
      formLabel: t(`indicators.fields.lower_tolerance_num`),
      columnHeader: t(`indicators.columns.lower_tolerance_num`),
      displayType: {
        displayType: 'number',
      },
    },
    LowerAppetiteNum: {
      fieldId: 'LowerAppetiteNum',
      formLabel: t(`indicators.fields.lower_appetite_num`),
      columnHeader: t(`indicators.columns.lower_appetite_num`),
      displayType: {
        displayType: 'number',
      },
    },
    UpperAppetiteNum: {
      fieldId: 'UpperAppetiteNum',
      formLabel: t(`indicators.fields.upper_appetite_num`),
      columnHeader: t(`indicators.columns.upper_appetite_num`),
      displayType: {
        displayType: 'number',
      },
    },
    UpperToleranceNum: {
      fieldId: 'UpperToleranceNum',
      formLabel: t(`indicators.fields.upper_tolerance_num`),
      columnHeader: t(`indicators.columns.upper_tolerance_num`),
      displayType: {
        displayType: 'number',
      },
    },
    TargetValueTxt: {
      fieldId: 'TargetValueTxt',
      formLabel: t(`indicators.fields.target_text_value`),
      columnHeader: t(`indicators.columns.target_text_value`),
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`indicators.fields.description`),
      displayType: { displayType: 'textarea' },
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t(`fields.Owner`),
      columnHeader: t(`columns.owners`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t(`fields.Contributor`),
      columnHeader: t(`columns.contributors`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Viewers: {
      fieldId: 'Viewers',
      formLabel: t(`fields.Viewer`),
      columnHeader: t(`columns.viewers`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    files: {
      fieldId: 'files',
      formLabel: t(`fields.newFiles`),
    },
    tags: {
      fieldId: 'tags',
      formLabel: t(`fields.Tags`),
      columnHeader: t(`columns.tags`),
      displayType: {
        displayType: 'tags',
      },
      allowAsConditionSource: true,
    },
    departments: {
      fieldId: 'departments',
      formLabel: t(`fields.Departments`),
      columnHeader: t(`columns.departments`),
      displayType: {
        displayType: 'departments',
      },
      allowAsConditionSource: true,
    },
  } as const satisfies FormConfig;
};
